/** Returns whether a URL is an absolute HTTPS URL safe for external navigation. */
export const isHttpsUrl = (url: string): boolean => {
  try {
    return new URL(url).protocol === 'https:'
  } catch {
    return false
  }
}
